import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "m-16"
};
const _hoisted_2 = {
  class: "wrap bg_white"
};
const _hoisted_3 = {
  class: "p-16"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_input = _resolveComponent("el-input");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("main", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
    class: "top-box"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: $options.exportHandle
      }, {
        default: _withCtx(() => _cache[27] || (_cache[27] = [_createElementVNode("i", {
          class: "Files"
        }, null, -1), _createTextVNode("导出")])),
        _: 1,
        __: [27]
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "m-t-16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_table, {
        border: "",
        ref: "xTable",
        "show-overflow": "",
        "cell-style": $options.cellStyle,
        "filter-config": {
          showIcon: false
        },
        "scroll-x": {
          enabled: false
        },
        data: $data.tableData
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_colgroup, {
          title: "任务编码",
          fixed: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "task_code",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_input, {
              size: "mini",
              modelValue: $data.filter.task_code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.filter.task_code = $event),
              onKeydown: _cache[1] || (_cache[1] = _withKeys($event => $options.getDataList(), ["enter", "native"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "任务类型",
          fixed: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "type_name",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.filter.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.filter.type = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[4] || (_cache[4] = $event => $options.clear('type'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.taskTypeList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value,
                  onClick: _cache[2] || (_cache[2] = $event => $options.getDataList())
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "任务状态",
          fixed: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "status_name",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.filter.status,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.filter.status = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[7] || (_cache[7] = $event => $options.clear('status'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.statusList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value,
                  onClick: _cache[5] || (_cache[5] = $event => $options.getDataList())
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "料车"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "cart_code_name",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.filter.cart_code,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.filter.cart_code = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[10] || (_cache[10] = $event => $options.clear('cart_code'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hopperCarList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.cart_title,
                  value: item.cart_code,
                  onClick: _cache[8] || (_cache[8] = $event => $options.getDataList())
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "AGV"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "vehicle_code_name",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.filter.vehicle_code,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.filter.vehicle_code = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[13] || (_cache[13] = $event => $options.clear('vehicle_code'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.AGVList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.agv_title,
                  value: item.agv_code,
                  onClick: _cache[11] || (_cache[11] = $event => $options.getDataList())
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "运输起点"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "start_address_code_name",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.filter.start_address_code,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.filter.start_address_code = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[16] || (_cache[16] = $event => $options.clear('start_address_code'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.addressList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.address_title,
                  value: item.address_code,
                  onClick: _cache[14] || (_cache[14] = $event => $options.getDataList())
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "运输终点"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "end_address_code_name",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.filter.end_address_code,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.filter.end_address_code = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[19] || (_cache[19] = $event => $options.clear('end_address_code'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.addressList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.address_title,
                  value: item.address_code,
                  onClick: _cache[17] || (_cache[17] = $event => $options.getDataList())
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "出入库类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "chu_type_name",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.filter.chu_type,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.filter.chu_type = $event),
              placeholder: "",
              clearable: "",
              filterable: "",
              size: "mini",
              onClear: _cache[22] || (_cache[22] = $event => $options.clear('chu_type'))
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.warehouseList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value,
                  onClick: _cache[20] || (_cache[20] = $event => $options.getDataList())
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "出入库单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "product_sn",
            width: "150"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_input, {
              size: "mini",
              modelValue: $data.filter.product_sn,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.filter.product_sn = $event),
              onKeydown: _cache[24] || (_cache[24] = _withKeys($event => $options.getDataList(), ["enter", "native"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_colgroup, {
          title: "物料信息"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "product_info",
            width: "300"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_input, {
              size: "mini",
              modelValue: $data.filter.sku,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.filter.sku = $event),
              onKeydown: _cache[26] || (_cache[26] = _withKeys($event => $options.getDataList(), ["enter", "native"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "ys_num",
          width: "120",
          title: "运输数量"
        }), _createVNode(_component_vxe_column, {
          field: "amount",
          width: "120",
          title: "单位"
        }), _createVNode(_component_vxe_column, {
          field: "create_author",
          width: "120",
          title: "创建人"
        }), _createVNode(_component_vxe_column, {
          field: "addtime",
          width: "150",
          title: "创建时间"
        }), _createVNode(_component_vxe_column, {
          field: "finishtime",
          width: "150",
          title: "完成时间"
        })]),
        _: 1
      }, 8, ["cell-style", "data"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_pagination, {
    class: "pagination m-t-16",
    "current-page": $data.filter.page,
    "page-sizes": [10, 20, 30, 40],
    "page-size": $data.filter.size,
    layout: "total, sizes, prev, pager, next, jumper",
    total: $data.total,
    onSizeChange: $options.changePageSize,
    onCurrentChange: $options.changePage
  }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])])]);
}